import React from "react";
import { BuyerProjectDeadline } from "@/types";
import { differenceInCalendarDays } from "date-fns";
import { DeadlineRow, DeadlineCard } from "./DeadlineItem";
import { useOptionConfigurator } from "../OptionConfiguratorContext";
import { useBreakpoint } from "@ygtechnologies/rubus-ui";

export const DeadlineList = ({ deadlines }: { deadlines: BuyerProjectDeadline[] }) => {
    const isExtraWide = useBreakpoint().up('xl');

    const { selectedDeadlineId, setSelectedDeadlineId } = useOptionConfigurator();

    const calculateDaysLeft = (deadline: BuyerProjectDeadline) =>
        differenceInCalendarDays(new Date(deadline.deadline), new Date());
    const color = (deadline: BuyerProjectDeadline) => {
        const daysLeft = calculateDaysLeft(deadline);
        if (!deadline.awaitingSignatures) return 'success';
        if (daysLeft < 0) return 'danger';
        if (daysLeft < 14) return 'warning';
        return 'info';
    };

    const handleSelectDeadline = (deadlineId: number) => {
        setSelectedDeadlineId(deadlineId);
    };

    const deadlinesWithOptions = deadlines.filter((d) => d.hasOptionsAttached);

    return deadlinesWithOptions.map((deadline) => {
        const props = {
            deadline,
            selectedDeadlineId,
            handleSelectDeadline,
            daysLeft: calculateDaysLeft(deadline),
            isSelected: deadline.id === selectedDeadlineId,
            color: color(deadline) as 'success' | 'warning' | 'info' | 'danger',
        };

        return isExtraWide ? <DeadlineRow key={deadline.id} {...props} /> : <DeadlineCard key={deadline.id} {...props} />;
    });
};
